<div class="modal-header">
  <h4>Profile - Change Password</h4>
  <button type="button" class="close-btn" (click)="close()">&times;</button>
</div>

<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-body">
    <div class="info-message">
      <strong>Info!</strong>
      Note: Strong password is required. A strong password consists of at least
      eight (8) characters and a combination of uppercase and lowercase letter,
      and number.
    </div>

    <div class="password-form">
      <label for="oldPassword">Old Password</label>
      <input
        id="oldPassword"
        type="password"
        maxlength="100"
        formControlName="oldPassword"
        autocomplete="current-password"
      />

      <label for="newPassword">New Password</label>
      <input
        id="newPassword"
        type="password"
        maxlength="100"
        formControlName="newPassword"
        autocomplete="new-password"
        (blur)="checkPasswordStrength()"
      />

      <label for="confirmPassword">Confirm New Password</label>
      <input
        id="confirmPassword"
        type="password"
        maxlength="100"
        formControlName="confirmPassword"
        autocomplete="new-password"
        (blur)="checkPasswordStrength()"
      />

      <div></div>
      <div class="strength-row">
        <span
          *ngIf="strengthMessage"
          class="strength-label"
          [class.strength-danger]="strengthState === 'danger'"
          [class.strength-warning]="strengthState === 'warning'"
          [class.strength-success]="strengthState === 'success'"
          [class.strength-info]="strengthState === 'info'"
        >
          {{ strengthMessage }}
        </span>
        <span *ngIf="checkingStrength" class="checking-label">Checking...</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="submit"
      class="regular-btn action-btn save-btn"
      [disabled]="!passwordValid || form.invalid || checkingStrength || saving"
    >
      <fa-icon [icon]="faSave"></fa-icon>
      {{ saving ? "Saving..." : "Save" }}
    </button>
    <button
      type="button"
      class="regular-btn action-btn clear-btn"
      (click)="close()"
      [disabled]="saving"
    >
      <fa-icon [icon]="faTimesCircle"></fa-icon>
      Close
    </button>
  </div>
</form>
